(() => {
  'use strict';
  const format = seconds => { const value = Math.max(0, Math.floor(seconds || 0)); return `${Math.floor(value / 60)}:${String(value % 60).padStart(2, '0')}`; };
  function init(root) {
    if (root.dataset.lkDemoReady) return;
    const config = JSON.parse(root.querySelector('[data-lk-demo-config]').textContent);
    const audio = root.querySelector('[data-lk-demo-audio]');
    if (!config.url || !config.peaks?.length) return;
    audio.src = config.url;
    const controls = root.querySelector('[data-lk-demo-controls]'), toggle = root.querySelector('[data-lk-demo-toggle]'), icon = root.querySelector('[data-lk-demo-icon]'), seek = root.querySelector('[data-lk-demo-seek]'), wave = root.querySelector('[data-lk-demo-wave]'), elapsed = root.querySelector('[data-lk-demo-elapsed]'), durationText = root.querySelector('[data-lk-demo-duration]'), status = root.querySelector('[data-lk-demo-status]');
    const copy = config.copy, lifetime = new AbortController(), options = { signal: lifetime.signal };
    let duration = config.duration, seeking = false, failed = false, playRequest = 0;
    const bars = config.peaks.map((peak, index) => {
      const bar = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      const height = Math.max(2, peak * 44); bar.setAttribute('x', index * 4); bar.setAttribute('y', (48 - height) / 2); bar.setAttribute('width', '2.5'); bar.setAttribute('height', height); bar.setAttribute('rx', '.6'); wave.append(bar); return bar;
    });
    function progress(time = audio.currentTime) {
      const fraction = Math.min(1, Math.max(0, time / (duration || 1)));
      if (!seeking) seek.value = Math.round(fraction * 1000);
      elapsed.textContent = format(time); durationText.textContent = format(duration);
      seek.setAttribute('aria-valuetext', `${format(time)} / ${format(duration)}`);
      wave.parentElement.style.setProperty('--lk-demo-progress', `${fraction * 100}%`);
      bars.forEach((bar, index) => bar.classList.toggle('is-played', index / bars.length < fraction));
    }
    function state() {
      const playing = !audio.paused && !audio.ended;
      toggle.setAttribute('aria-pressed', String(playing)); toggle.setAttribute('aria-label', playing ? copy.pause : failed ? copy.retry : copy.play); icon.textContent = playing ? 'Ⅱ' : '▶';
    }
    async function play() {
      const request = ++playRequest;
      if (!audio.paused) { audio.pause(); return; }
      if (failed) { audio.load(); failed = false; }
      if (audio.ended) audio.currentTime = 0;
      status.textContent = '';
      try { await audio.play(); if (request === playRequest) state(); }
      catch (error) { if (error.name !== 'AbortError' && request === playRequest) { status.textContent = copy.error; failed = true; state(); } }
    }
    toggle.addEventListener('click', play, options);
    seek.addEventListener('input', () => { seeking = true; progress(Number(seek.value) / 1000 * duration); }, options);
    seek.addEventListener('change', () => {
      const time = Number(seek.value) / 1000 * duration; seeking = false;
      if (Number.isFinite(audio.duration)) audio.currentTime = Math.min(time, audio.duration);
      progress(time);
    }, options);
    audio.addEventListener('loadedmetadata', () => { duration = Number.isFinite(audio.duration) ? audio.duration : config.duration; seek.disabled = false; progress(); }, options);
    audio.addEventListener('timeupdate', () => { if (!seeking) progress(); }, options);
    audio.addEventListener('play', () => {
      document.dispatchEvent(new CustomEvent('lk:stop-audio'));
      document.dispatchEvent(new CustomEvent('lk:demo-play', { detail: { root } }));
      failed = false; status.textContent = ''; state();
    }, options);
    audio.addEventListener('playing', () => { toggle.removeAttribute('aria-busy'); status.textContent = ''; }, options);
    audio.addEventListener('waiting', () => { if (!audio.paused) { toggle.setAttribute('aria-busy', 'true'); status.textContent = copy.loading; } }, options);
    ['pause', 'ended'].forEach(event => audio.addEventListener(event, () => { toggle.removeAttribute('aria-busy'); state(); progress(); }, options));
    audio.addEventListener('error', () => { failed = true; toggle.removeAttribute('aria-busy'); status.textContent = copy.error; state(); }, options);
    document.addEventListener('lk:audio-state', event => { if (event.detail?.playing) { ++playRequest; audio.pause(); } }, options);
    document.addEventListener('lk:demo-play', event => { if (event.detail?.root !== root) { ++playRequest; audio.pause(); } }, options);
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) { audio.pause(); lifetime.abort(); } }, options);
    seek.disabled = !Number.isFinite(audio.duration);
    audio.controls = false; controls.hidden = false; root.classList.add('is-enhanced'); root.dataset.lkDemoReady = 'true'; progress(); state();
  }
  const start = () => document.querySelectorAll('[data-lk-native-demo]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
